import { CompanyCollectionItemData } from "../to-be-removed/LocalData/Company/Collections/CompanyCollectionItemData";
import { PropertyCollectionItemData } from "../to-be-removed/LocalData/Property/Collections/PropertyCollectionItemData";
import { PropertyCollectionData } from "../to-be-removed/LocalData/Property/Collections/PropertyCollectionData";
import { CollectionUtilities } from "./collectionUtilities";
import { CollectionItemData } from "../to-be-removed/LocalData/collections/CollectionItemData";

export class FormulaUtilities {
  static split(expression: string, operator: string): string[] {
    const result = [];
    let braces = 0;
    let currentChunk = "";
    for (let i = 0; i < expression.length; ++i) {
      const curCh = expression[i];
      if (curCh === "(") {
        braces++;
      } else if (curCh === ")") {
        braces--;
      }
      if (braces === 0 && operator === curCh) {
        result.push(currentChunk);
        currentChunk = "";
      } else currentChunk += curCh;
    }
    if (currentChunk !== "") {
      result.push(currentChunk);
    }
    return result;
  }

  static async parseExpression(
    expression: string,
    item: PropertyCollectionItemData | CompanyCollectionItemData | CollectionItemData
  ): Promise<number> {
    let numbersString = FormulaUtilities.split(expression, "+");
    numbersString = numbersString.map((field) => (field === "" ? "0" : field)); // NOT PROPERLY TESTED

    const numbers = await Promise.all(numbersString.map((noStr) => FormulaUtilities.parseMinusSeparatedExpression(noStr, item)));
    const initialValue = 0.0;
    return numbers.reduce((previousValue, currentValue) => previousValue + currentValue, initialValue);
  }

  static async parseMinusSeparatedExpression(
    expression: string,
    item: PropertyCollectionItemData | CompanyCollectionItemData | CollectionItemData
  ): Promise<number> {
    let numbersString = FormulaUtilities.split(expression, "-");
    numbersString = numbersString.map((field) => (field === "" ? "0" : field)); // NOT PROPERLY TESTED

    const numbers = await Promise.all(numbersString.map((noStr) => FormulaUtilities.parseMultiplicationSeparatedExpression(noStr, item)));
    const initialValue = numbers[0];
    return numbers.slice(1).reduce((acc, no) => acc - no, initialValue);
  }

  static async parseMultiplicationSeparatedExpression(
    expression: string,
    item: PropertyCollectionItemData | CompanyCollectionItemData | CollectionItemData
  ): Promise<number> {
    const numbersString = FormulaUtilities.split(expression, "*");
    const numbers = await Promise.all(
      numbersString.map((noStr) => {
        if (noStr[0] === "(") {
          const expr = noStr.substr(1, noStr.length - 2);
          return FormulaUtilities.parseExpression(expr, item);
        }
        return FormulaUtilities.parseDivisionSeparatedExpression(noStr, item);
      })
    );

    const initialValue = 1.0;
    return numbers.reduce((acc, no) => acc * no, initialValue);
  }

  static async parseDivisionSeparatedExpression(
    expression: string,
    item: PropertyCollectionItemData | CompanyCollectionItemData | CollectionItemData
  ): Promise<number> {
    const numbersString = FormulaUtilities.split(expression, "/");
    const numbers = await Promise.all(
      numbersString.map((noStr) => {
        if (noStr[0] === "(") {
          const expr = noStr.substr(1, noStr.length - 2);
          return FormulaUtilities.parseExpression(expr, item);
        }
        return FormulaUtilities.parseFieldExpression(noStr, item);
      })
    );

    const initialValue = numbers[0];
    return numbers.slice(1).reduce((acc, no) => acc / no, initialValue);
  }

  static async parseFieldExpression(
    expression: string,
    item: PropertyCollectionItemData | CompanyCollectionItemData | CollectionItemData
  ): Promise<number> {
    if (expression.startsWith("field")) {
      expression = expression.substring("field".length + 1, expression.length - 1);
      const parent = item.parent instanceof PropertyCollectionData ? item.parent : undefined;
      const field = parent?.customFields.getData(expression);
      if (field && expression in item.fields) {
        if (!(item instanceof CollectionItemData)) expression = await CollectionUtilities.getValueString(item.fields[expression], field, item);
      }
      return this.parseExpression(expression, item);
    }
    return +expression;
  }
}

